import CompanyDeviceScreensTab from './CompanyDeviceScreensTab';

export default CompanyDeviceScreensTab;
